'use client'
const isInIframe = () => window.self !== window.top;

export { isInIframe };
